import { httpGet } from "../api/request/requestApi";
const controllerEndpoint = "els/tags";
export class TagsApi {
    static list(params) {
        var _a, _b;
        const page = (_a = params.page) !== null && _a !== void 0 ? _a : 0;
        const size = (_b = params.size) !== null && _b !== void 0 ? _b : 20;
        const search = params.search ? `&keyword=${encodeURIComponent(params.search)}` : "";
        return httpGet(`${controllerEndpoint}?page=${page}&size=${size}${search}`, { silent: true });
    }
}
